import { SessionRevokeAction } from '@kaltura-ott/ott-client-types/api/types';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';

/**
 * Build request payload for service 'Session' action 'Revoke'.
 *
 * Usage: revoke session
 *
 * @category LogOut
 * @function
 */

export const revokeSession = () => {
  const client = kalturaClient();
  const action = new SessionRevokeAction();
  return client.request(action).pipe(
    catchError((error) => {
      console.warn(error);
      return throwError(error);
    }),
  );
};
